import { useNavigate } from "react-router-dom";

export const BackButton = () => {
    const isButtonVisible = window.history.state?.usr?.canGoBack === true;

    const navigateTo = useNavigate();
    const goBack = () => {
        navigateTo(-1);
    };

    return (
        <div>
            {isButtonVisible && (
                <button
                    type="button"
                    className="btn border-0 text-white p-0 rounded-3 back-button bg-dark"
                    onClick={goBack}
                    aria-label="Go back"
                    title="Go back"
                    data-testid="back-button"
                >
                    <i className="fa-solid fa-arrow-left" />
                </button>
            )}
        </div>
    );
};
